import * as Styled from "./style";
import { RegisterPremiumButton } from "~/components/blocks/layout/global-navi/common/user-menu/appeal-for-premium-plan/register-premium-button";

type Props = {
  onHideUserMenu: () => void;
};

export const AppealForPremiumPlan = (props: Props) => {
  const { onHideUserMenu } = props;

  return (
    <Styled.DivBorderContainer>
      <Styled.DivContentWrapper>
        <Styled.DivAppealTextWrapper>
          <Styled.SpanAppealText>対象の作品が見放題！</Styled.SpanAppealText>
          <Styled.SpanAppealText>30日間無料トライアル</Styled.SpanAppealText>
        </Styled.DivAppealTextWrapper>

        <RegisterPremiumButton onHideUserMenu={onHideUserMenu} />
      </Styled.DivContentWrapper>
    </Styled.DivBorderContainer>
  );
};
